import { Box } from '@material-ui/core';
import { IconButtons } from './ResponsiveContainers';

function ButtonBKSystem({ toggleTooltip, isTooltipVisible, anchorEl }) {
  return (
    <IconButtons
      title="Các ứng dụng của Bách Khoa Technology"
      className="tooltip-container"
      onClick={(e) => toggleTooltip(e)}>
      <div className={`${isTooltipVisible ? 'click flex' : 'flex'}`}>
        <Box
          component="img"
          src={
            process.env.REACT_APP_STATIC_URL +
            'content/assets/images/dots-menu.png'
          }
          sx={{
            color: '#fff',
            width: '30px',
            height: '30px'
          }}
        />
      </div>
    </IconButtons>
  );
}

export default ButtonBKSystem;
